import { ToastrService } from 'ngx-toastr';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { WebSiteUsersService } from '@app/services/webSiteUsers/webSiteUsers.service';
import { OrdersService } from '@app/services/order/orders.service';

@Component({
    selector: 'forgetpassword',
    templateUrl: 'forgetpassword.component.html',
    styleUrls: ['forgetpassword.component.scss']
})
export class ForgetpasswordComponent {
    email = "";
    loader: boolean = false;
    ourApp = false;
    constructor(
        private toastr: ToastrService,
        private webSiteUsersService: WebSiteUsersService,
        private router: Router,
        private orderService : OrdersService
    ) {
        this.orderService.ourAppEvent.subscribe(
            data => {
                this.ourApp = data;
            }
        )
    }
    send() {
        this.loader = true;
        if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email))) {
            this.toastr.error('Merci de saisir une adresse email valide', 'Attention !');
            this.loader = false;
        } else {
            this.webSiteUsersService.forgetPassword(this.email).subscribe(
                (data: any) => {
                    if (data.success) {
                        this.toastr.success('Merci de consulter votre boite email pour obtenir votre mot de passe');
                        this.router.navigate(['/compte/connexion']);
                    } else {
                        this.toastr.error('Aucun compte correspondant à votre email', 'Attention !');
                        this.loader = false;
                    }
                },
                () => {
                    this.loader = false;
                }
            )
        }
    }
}
